import { KeyValue } from '@/main/models/common';
import { TemplateEmailNotificationTypes, DomainBySystemApplicationActionTypes } from './templateEmailNotificationTypes';
import { DomainBySystemApplicationRequest } from '@/main/models/request/templateEmailNotificationRequest';

export function getDomainBySystemApplication(request?: DomainBySystemApplicationRequest): DomainBySystemApplicationActionTypes {
  return {
    type: TemplateEmailNotificationTypes.GET_DOMAIN_BY_SYSTEM_APPLICATION,
    payload: {
      request
    }
  };
}

export function saveDomainBySystemApplication(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): DomainBySystemApplicationActionTypes {
  return {
    type: TemplateEmailNotificationTypes.SAVE_DOMAIN_BY_SYSTEM_APPLICATION,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerDomainBySystemApplication(): DomainBySystemApplicationActionTypes {
  return {
    type: TemplateEmailNotificationTypes.RESET_REDUCER_DOMAIN_BY_SYSTEM_APPLICATION
  };
}
